import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconCapitalLetterA = SvgIcon({
    children: jsx("path", { d: "M14.312 16H15.8L12.764 7.6H11.108L8.06 16H9.56L10.148 14.308H13.724L14.312 16ZM10.604 13.012L11.936 9.22L13.268 13.012H10.604Z" }),
});

export { IconCapitalLetterA };
